// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"Bdz6_","header":"_1XU7E","left":"cOr8e","menuButton":"_2dh7K","profile":"_1ppxk"};


//////////////////
// WEBPACK FOOTER
// ./app/components/header/header.scss
// module id = 1501
// module chunks = 0